var map = {
	"./AppCollapse.vue": 5895,
	"./AppCollapseItem.vue": 1369,
	"./AppCollapseTransition.vue": 5465,
	"./AppCookieConsent.vue": 9625,
	"./AppRate.vue": 6619,
	"./Avatar.vue": 5995,
	"./LocaleToggler.vue": 6383,
	"./ThemeToggler.vue": 1231,
	"./favorite.vue": 8396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5985;